import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export interface DeviceInfo {
  platform: string;
  deviceId: string;
  appVersion: string;
}

export const getDeviceInfo = async (): Promise<DeviceInfo> => {
  const platform = Capacitor.getPlatform(); // 'ios', 'android', 'web'

  let deviceId = 'unknown';
  try {
    const id = await Device.getId();
    deviceId = id.identifier;
  } catch {
    // Do Nothing
  }

  let appVersion = 'unknown';
  try {
    const info = await App.getInfo();
    appVersion = info.version;
  } catch {
        // Do Nothing
  } // App.getInfo() throws on web

  return { platform, deviceId, appVersion };
};